namespace Matrix.Data {
    export interface PartyRoleForm {
        RoleCode: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        PartyList: PartyRolePartiesEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class PartyRoleForm extends Serenity.PrefixedContext {
        static formKey = 'Data.PartyRole';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PartyRoleForm.init)  {
                PartyRoleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = PartyRolePartiesEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(PartyRoleForm, [
                    'RoleCode', w0,
                    'Description', w0,
                    'PartyList', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
